export default "/static/build/preland-card-1.png";